import { Card, Status } from '@gatecheckpro/design-system';
import { Chrome } from './Chrome.tsx';
import { useViewer } from '../lib/session.tsx';

export function AccountPage() {
  const viewer = useViewer();

  return (
    <Chrome>
      <main className="gc-main">
        <div className="gc-container gc-stack gc-stack--loose" style={{ maxWidth: '40rem' }}>
          <div className="gc-page-header">
            <span className="gc-eyebrow">Your account</span>
            <h1>{viewer.displayName}</h1>
          </div>

          <Card title="Contact details">
            <div className="gc-stack">
              <div className="gc-row gc-row--between">
                <span>{viewer.email}</span>
                <Status
                  tone={viewer.emailVerified ? 'positive' : 'neutral'}
                  label={viewer.emailVerified ? 'Verified' : 'Not verified'}
                />
              </div>
              {viewer.phone !== null && (
                <div className="gc-row gc-row--between">
                  <span className="gc-mono">{viewer.phone}</span>
                  <Status
                    tone={viewer.phoneVerified ? 'positive' : 'neutral'}
                    label={viewer.phoneVerified ? 'Verified' : 'Not verified'}
                  />
                </div>
              )}
              <p className="gc-muted">
                Verification messages are not sent in this release. Nothing on your account is
                blocked by it today.
              </p>
            </div>
          </Card>

          <Card title="Security">
            <div className="gc-stack gc-stack--tight">
              <div className="gc-row">
                <Status
                  tone={viewer.mfa.enrolled ? 'positive' : 'neutral'}
                  label={
                    viewer.mfa.enrolled ? 'Authenticator app enrolled' : 'No authenticator app'
                  }
                />
              </div>
              <p className="gc-muted">
                A second factor is not required for an attendee account. It becomes worth having
                once tickets can be transferred out of it.
              </p>
            </div>
          </Card>

          <Card title="Organizing an event?">
            <p className="gc-muted">
              GateCheckPro is the organizer and gate-control side of the same platform, and it uses
              this same account. It runs separately at its own address.
            </p>
          </Card>
        </div>
      </main>
    </Chrome>
  );
}
